module.exports = __webpack_public_path__ + "f12d6573338a5c977d2ea0743530346b.png";